module.exports = __webpack_public_path__ + "static/media/2-audio.27e423c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/2-audio.wav
// module id = rjRk
// module chunks = 1